export default function hamburgersInit(props) {
    const {
        hamburgerClassSelector,
        headerMenuClassSelector,
        headerMenuLinksClassSelector,
    } = props

    const hamburgerEl = document.querySelector( hamburgerClassSelector )
    const menuItemsEls = document.querySelectorAll( headerMenuLinksClassSelector )
    const headerMenuEl = document.querySelector( headerMenuClassSelector )

    if ( ! hamburgerEl ) {
        return
    }

    hamburgerEl.addEventListener('click', (e) => {
        if ( ! headerMenuEl ) {
            return
        }

        hamburgerEl.classList.toggle('is-active')

        document.querySelector('body').classList.toggle('show-menu')

        if ( hamburgerEl.classList.contains('is-active') ) {
            headerMenuEl.classList.add('active');
        } else {
            headerMenuEl.classList.remove('active');
        }
    })

    menuItemsEls.forEach(menuItemEl => {
        menuItemEl.addEventListener('click', (e) => {
            hamburgerEl?.classList.remove('is-active')
            headerMenuEl?.classList.remove('active');
            document.body.classList.remove('show-menu');
        })
    })
}
